"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.tricuspidInsufficiencyMessages = exports.aorticInsufficiencyMessages = exports.mitralInsufficiencyMessages = exports.diastolicDysfunctionMessages = exports.TricuspidInsufficiency = exports.AorticInsufficiency = exports.MitralInsufficiency = exports.DiastolicDysfunction = void 0;
const schema_1 = require("../../../schema");
var DiastolicDysfunction;
(function (DiastolicDysfunction) {
    DiastolicDysfunction["YES"] = "YES";
    DiastolicDysfunction["NO"] = "NO";
    DiastolicDysfunction["NOT_MEASURED"] = "NOT_MEASURED";
})(DiastolicDysfunction || (exports.DiastolicDysfunction = DiastolicDysfunction = {}));
var MitralInsufficiency;
(function (MitralInsufficiency) {
    MitralInsufficiency["GR_0"] = "Gr. 0";
    MitralInsufficiency["GR_I"] = "Gr. I";
    MitralInsufficiency["GR_I_II"] = "Gr. I-II";
    MitralInsufficiency["GR_II"] = "Gr. II";
    MitralInsufficiency["GR_II_III"] = "Gr. II-III";
    MitralInsufficiency["GR_III"] = "Gr. III";
    MitralInsufficiency["GR_III_IV"] = "Gr. III-IV";
    MitralInsufficiency["GR_IV"] = "Gr. IV";
})(MitralInsufficiency || (exports.MitralInsufficiency = MitralInsufficiency = {}));
var AorticInsufficiency;
(function (AorticInsufficiency) {
    AorticInsufficiency["GR_0"] = "Gr. 0";
    AorticInsufficiency["GR_I"] = "Gr. I";
    AorticInsufficiency["GR_I_II"] = "Gr. I-II";
    AorticInsufficiency["GR_II"] = "Gr. II";
    AorticInsufficiency["GR_II_III"] = "Gr. II-III";
    AorticInsufficiency["GR_III"] = "Gr. III";
    AorticInsufficiency["GR_III_IV"] = "Gr. III-IV";
    AorticInsufficiency["GR_IV"] = "Gr. IV";
})(AorticInsufficiency || (exports.AorticInsufficiency = AorticInsufficiency = {}));
var TricuspidInsufficiency;
(function (TricuspidInsufficiency) {
    TricuspidInsufficiency["GR_0"] = "Gr. 0";
    TricuspidInsufficiency["GR_I"] = "Gr. I";
    TricuspidInsufficiency["GR_I_II"] = "Gr. I-II";
    TricuspidInsufficiency["GR_II"] = "Gr. II";
    TricuspidInsufficiency["GR_II_III"] = "Gr. II-III";
    TricuspidInsufficiency["GR_III"] = "Gr. III";
    TricuspidInsufficiency["GR_III_IV"] = "Gr. III-IV";
    TricuspidInsufficiency["GR_IV"] = "Gr. IV";
})(TricuspidInsufficiency || (exports.TricuspidInsufficiency = TricuspidInsufficiency = {}));
exports.diastolicDysfunctionMessages = {
    [DiastolicDysfunction.YES]: {
        id: "htx.currentCardiologicalState.echocardiography.diastolicDysfunction.YES",
        defaultMessage: "Van"
    },
    [DiastolicDysfunction.NO]: {
        id: "htx.currentCardiologicalState.echocardiography.diastolicDysfunction.NO",
        defaultMessage: "Nincs"
    },
    [DiastolicDysfunction.NOT_MEASURED]: {
        id: "htx.currentCardiologicalState.echocardiography.diastolicDysfunction.NOT_MEASURED",
        defaultMessage: "Nem vizsgált"
    }
};
exports.mitralInsufficiencyMessages = {
    [MitralInsufficiency.GR_0]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_0",
        defaultMessage: "Gr. 0"
    },
    [MitralInsufficiency.GR_I]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_I",
        defaultMessage: "Gr. I"
    },
    [MitralInsufficiency.GR_I_II]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_I_II",
        defaultMessage: "Gr. I-II"
    },
    [MitralInsufficiency.GR_II]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_II",
        defaultMessage: "Gr. II"
    },
    [MitralInsufficiency.GR_II_III]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_II_III",
        defaultMessage: "Gr. II-III"
    },
    [MitralInsufficiency.GR_III]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_III",
        defaultMessage: "Gr. III"
    },
    [MitralInsufficiency.GR_III_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_III_IV",
        defaultMessage: "Gr. III-IV"
    },
    [MitralInsufficiency.GR_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.mitralInsufficiency.GR_IV",
        defaultMessage: "Gr. IV"
    }
};
exports.aorticInsufficiencyMessages = {
    [AorticInsufficiency.GR_0]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_0",
        defaultMessage: "Gr. 0"
    },
    [AorticInsufficiency.GR_I]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_I",
        defaultMessage: "Gr. I"
    },
    [AorticInsufficiency.GR_I_II]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_I_II",
        defaultMessage: "Gr. I-II"
    },
    [AorticInsufficiency.GR_II]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_II",
        defaultMessage: "Gr. II"
    },
    [AorticInsufficiency.GR_II_III]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_II_III",
        defaultMessage: "Gr. II-III"
    },
    [AorticInsufficiency.GR_III]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_III",
        defaultMessage: "Gr. III"
    },
    [AorticInsufficiency.GR_III_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_III_IV",
        defaultMessage: "Gr. III-IV"
    },
    [AorticInsufficiency.GR_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.aorticInsufficiency.GR_IV",
        defaultMessage: "Gr. IV"
    }
};
exports.tricuspidInsufficiencyMessages = {
    [TricuspidInsufficiency.GR_0]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_0",
        defaultMessage: "Gr. 0"
    },
    [TricuspidInsufficiency.GR_I]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_I",
        defaultMessage: "Gr. I"
    },
    [TricuspidInsufficiency.GR_I_II]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_I_II",
        defaultMessage: "Gr. I-II"
    },
    [TricuspidInsufficiency.GR_II]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_II",
        defaultMessage: "Gr. II"
    },
    [TricuspidInsufficiency.GR_II_III]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_II_III",
        defaultMessage: "Gr. II-III"
    },
    [TricuspidInsufficiency.GR_III]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_III",
        defaultMessage: "Gr. III"
    },
    [TricuspidInsufficiency.GR_III_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_III_IV",
        defaultMessage: "Gr. III-IV"
    },
    [TricuspidInsufficiency.GR_IV]: {
        id: "htx.currentCardiologicalState.echocardiography.tricuspidInsufficiency.GR_IV",
        defaultMessage: "Gr. IV"
    }
};
const ejectionFraction = schema_1.Schema.number()
    .optional()
    .unit("%")
    .integer()
    .min(5)
    .max(80)
    .interpretation({ vocab: "htx", code: "ejection_fraction" })
    .tag({ vocab: "snomed", code: "250908004" })
    .tag({ vocab: "loinc", code: "10230-1" });
const edd = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(30)
    .max(200)
    .interpretation({ vocab: "htx", code: "edd" })
    .tag({ vocab: "snomed", code: "250929008" });
const swt = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(3)
    .max(40)
    .interpretation({ vocab: "htx", code: "septal_wall_thickness" });
const pwt = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(3)
    .max(40)
    .interpretation({ vocab: "htx", code: "posterior_wall_thickness" });
const laDiameter1 = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(5)
    .max(80)
    .interpretation({ vocab: "htx", code: "left_atrial_diameter1" });
const laDiameter2 = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(5)
    .max(80)
    .interpretation({ vocab: "htx", code: "left_atrial_diameter2" });
const raDiameter1 = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(5)
    .max(80)
    .interpretation({ vocab: "htx", code: "right_atrial_diameter1" });
const raDiameter2 = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(5)
    .max(80)
    .interpretation({ vocab: "htx", code: "right_atrial_diameter2" });
const aorticRootSize = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(3)
    .max(40)
    .interpretation({ vocab: "htx", code: "aortic_root_size" })
    .tag({ vocab: "snomed", code: "8128003" });
const aortaAscendensSize = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(3)
    .max(70)
    .interpretation({ vocab: "htx", code: "artoa_ascendens_size" })
    .tag({ vocab: "snomed", code: "54247002" });
const rvSize = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(3)
    .max(100)
    .interpretation({ vocab: "htx", code: "rv_size" })
    .tag({ vocab: "snomed", code: "250964004" });
const tapse = schema_1.Schema.number()
    .optional()
    .unit("mm")
    .integer()
    .min(1)
    .max(30)
    .interpretation({ vocab: "htx", code: "TAPSE" });
const diastolicDysfunction = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DiastolicDysfunction.YES),
    schema_1.Schema.singleChoiceItem(DiastolicDysfunction.NO),
    schema_1.Schema.singleChoiceItem(DiastolicDysfunction.NOT_MEASURED)
])
    .optional()
    .interpretation({ vocab: "htx", code: "diastolic_dysfunction" })
    .tag({ vocab: "snomed", code: "3545003" });
const mitralInsufficiency = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_0),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_I),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_I_II),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_II),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_II_III),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_III),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_III_IV),
    schema_1.Schema.singleChoiceItem(MitralInsufficiency.GR_IV)
])
    .optional()
    .interpretation({ vocab: "htx", code: "mitral_insufficiency" })
    .tag({ vocab: "snomed", code: "48724000" })
    .tag({ vocab: "loinc", code: "18113-1" });
const aorticInsufficiency = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_0),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_I),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_I_II),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_II),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_II_III),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_III),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_III_IV),
    schema_1.Schema.singleChoiceItem(AorticInsufficiency.GR_IV)
])
    .optional()
    .interpretation({ vocab: "htx", code: "aortic_insufficiency" })
    .tag({ vocab: "snomed", code: "60234000" })
    .tag({ vocab: "loinc", code: "18112-3" });
const aorticValveGradient = schema_1.Schema.number()
    .optional()
    .integer()
    .min(0)
    .max(200)
    .interpretation({ vocab: "htx", code: "aortic_valve_gradient" })
    .tag({ vocab: "snomed", code: "251088005" })
    .tag({ vocab: "loinc", code: "18066-1" });
const tricuspidInsufficiency = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_0),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_I),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_I_II),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_II),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_II_III),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_III),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_III_IV),
    schema_1.Schema.singleChoiceItem(TricuspidInsufficiency.GR_IV)
])
    .optional()
    .interpretation({ vocab: "htx", code: "tricuspid_insufficiency" })
    .tag({ vocab: "snomed", code: "111287006" })
    .tag({ vocab: "loinc", code: "18115-6" });
const estimatedRightVentricularPeakSystolicPressure = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .integer()
    .min(0)
    .max(100)
    .interpretation({
    vocab: "htx",
    code: "estimated_right_ventricular_peak_systolic_pressure"
})
    .tag({ vocab: "snomed", code: "399023006" });
const description = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "htx", code: "echocardiography_summary" })
    .tag({ vocab: "snomed", code: "371534008" })
    .tag({ vocab: "loinc", code: "55112-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    ejectionFraction,
    edd,
    swt,
    pwt,
    laDiameter1,
    laDiameter2,
    raDiameter1,
    raDiameter2,
    aorticRootSize,
    aortaAscendensSize,
    rvSize,
    tapse,
    diastolicDysfunction,
    mitralInsufficiency,
    aorticInsufficiency,
    aorticValveGradient,
    tricuspidInsufficiency,
    estimatedRightVentricularPeakSystolicPressure,
    description
})
    .interpretation({ vocab: "htx", code: "echocardiography" })
    .tag({ vocab: "snomed", code: "40701008" })
    .tag({ vocab: "loinc", code: "42148-7" })
    .tag({ vocab: "snomed", code: "243806009" });
